import React from 'react';
import styled from 'styled-components';

const Terms = () => {
  return (
    <PageContainer>
      <Section>
        <ContentWrapper>
          <PagePill>Legal</PagePill>

          <MainHeading>Terms &amp; Conditions</MainHeading>

          <IntroText>
            These Terms &amp; Conditions govern your access to and use of the
            website sonorai.co (the "Website") and any services offered by us.
            By accessing the Website or engaging our services you accept these
            Terms.
          </IntroText>

          <ContentSection>
            <SectionHeading>1. Website Operator</SectionHeading>
            <InfoText>
              The Website is operated by:
            </InfoText>
            <InfoText>
              Elgazzar Ventures LLC<br />
              Brand: Sonorai<br />
              33 North Gould Street, Sheridan, WY 82801, United States<br />
              Phone: <a href="tel:+17372822831">+1 (737) 282-2831</a><br />
              Email: <a href="mailto:mohamed@sonorai.co">mohamed@sonorai.co</a>
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>2. Use of the Website</SectionHeading>
            <InfoText>
              You may use the Website for lawful, personal, and business
              purposes. You agree not to: (a) use the Website in a way that
              violates any applicable law or regulation; (b) interfere with the
              operation or security of the Website; (c) attempt to gain
              unauthorized access to any part of the Website, its systems, or
              its data; (d) use automated means to scrape, copy, or extract
              content without our prior written consent.
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>3. Services</SectionHeading>
            <InfoText>
              We provide technology, AI automation, CRM, workflow, and related
              consulting and implementation services for businesses. The exact
              scope, deliverables, timelines, and fees of any engagement are
              governed by a separate written proposal, statement of work, or
              agreement signed with you ("Service Agreement"). The Website
              itself is informational and does not, on its own, constitute an
              offer to enter into a Service Agreement.
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>4. No Guarantee of Specific Results</SectionHeading>
            <InfoText>
              We work hard to deliver value, but we do not guarantee any
              specific business, financial, revenue, lead, booking, or
              operational result. Any examples, case studies, testimonials,
              metrics, or estimates shown on the Website are illustrative and
              are not a promise that you will achieve the same results.
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>5. Intellectual Property</SectionHeading>
            <InfoText>
              The Website and its content (including text, design, logos,
              graphics, code, video, and audio) are owned by Elgazzar Ventures LLC
              or its licensors and are protected by Italian, EU, and
              international copyright and intellectual property laws. Except
              for the limited rights necessary to view the Website, no licence
              is granted to you. You may not reproduce, republish, distribute,
              modify, sell, or create derivative works from any part of the
              Website without our prior written consent.
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>6. User Responsibilities</SectionHeading>
            <InfoText>
              You are responsible for the accuracy of any information you
              submit to us, for keeping your own credentials and accounts
              secure, for complying with applicable laws (including data
              protection, telemarketing, and consumer protection laws) in your
              own operations, and for backing up any data you provide to or
              receive from us.
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>7. Payment and Refunds</SectionHeading>
            <InfoText>
              Fees, invoicing terms, payment terms, and refund policy for any
              engagement are governed by the individual Service Agreement,
              proposal, or order signed with you. Where no specific written
              terms exist, fees are payable upon invoice and amounts already
              paid for work performed are non-refundable to the extent
              permitted by applicable law.
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>8. Third-Party Links and Services</SectionHeading>
            <InfoText>
              The Website may link to or embed third-party services
              (including, for example, Cal.com, YouTube, and other providers).
              We do not control those services and are not responsible for
              their content, availability, or practices. Your use of those
              services is governed by their own terms and privacy policies.
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>9. Disclaimer</SectionHeading>
            <InfoText>
              To the maximum extent permitted by applicable law, the Website
              and its content are provided "as is" and "as available", without
              warranties of any kind, either express or implied, including
              warranties of merchantability, fitness for a particular purpose,
              or non-infringement. We do not warrant that the Website will be
              uninterrupted, error-free, or fully secure.
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>10. Limitation of Liability</SectionHeading>
            <InfoText>
              To the maximum extent permitted by applicable law, we will not be
              liable for any indirect, incidental, special, consequential,
              punitive, or exemplary damages, or for any loss of profits,
              revenue, data, goodwill, or business opportunities arising from
              or related to your use of the Website. Nothing in these Terms
              limits or excludes liability that cannot lawfully be limited or
              excluded under Italian or EU law, including liability for fraud
              or for personal injury caused by negligence.
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>11. Communications and SMS</SectionHeading>
            <InfoText>
              Where you provide your phone number and opt in to SMS, the use
              of those communications is governed by our{' '}
              <a href="#sms-terms">SMS Terms</a> and our{' '}
              <a href="#privacy">Privacy Policy</a>.
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>12. Changes</SectionHeading>
            <InfoText>
              We may update these Terms from time to time. The latest version
              will always be available on this page with the "last updated"
              date below. Continued use of the Website after a change
              constitutes acceptance of the updated Terms.
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>13. Governing Law and Jurisdiction</SectionHeading>
            <InfoText>
              These Terms and any matter arising from them are governed by the
              laws of Italy, without regard to its conflict-of-laws rules,
              unless otherwise agreed in writing with you. The courts of Monza
              (Italy) shall have non-exclusive jurisdiction, without prejudice
              to mandatory consumer protection rights you may have under EU or
              Italian law.
            </InfoText>
          </ContentSection>

          <ContentSection>
            <SectionHeading>14. Contact</SectionHeading>
            <InfoText>
              For any question about these Terms, contact us at{' '}
              <a href="mailto:mohamed@sonorai.co">mohamed@sonorai.co</a>.
            </InfoText>
          </ContentSection>

          <LastUpdated>Company details updated: September 10, 2026</LastUpdated>
        </ContentWrapper>
      </Section>
    </PageContainer>
  );
};

const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
  background-color: var(--bg-0);
`;

const Section = styled.section`
  padding: 120px 20px 100px;
  max-width: 1200px;
  margin: 0 auto;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 780px;
  margin: 0 auto;
`;

const PagePill = styled.div`
  display: inline-block;
  padding: 6px 14px;
  background-color: var(--bg-2);
  border: 1px solid var(--line-2);
  border-radius: 9999px;
  color: var(--fg-2);
  font-family: var(--mono);
  font-size: 11px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.28px;
  margin-bottom: 24px;
  align-self: flex-start;
`;

const MainHeading = styled.h1`
  font-family: var(--display);
  font-size: 56px;
  font-weight: 400;
  letter-spacing: -1.6px;
  color: var(--fg-0);
  margin: 0 0 24px;
  line-height: 1.05;

  @media (max-width: 768px) {
    font-size: 40px;
    letter-spacing: -1px;
  }
`;

const IntroText = styled.p`
  font-family: var(--body);
  font-size: 17px;
  line-height: 1.55;
  color: var(--fg-2);
  margin: 0 0 48px;
  max-width: 680px;
`;

const ContentSection = styled.div`
  margin-bottom: 36px;
`;

const SectionHeading = styled.h2`
  font-family: var(--body);
  font-size: 18px;
  font-weight: 600;
  color: var(--fg-0);
  margin: 0 0 12px;
  letter-spacing: -0.2px;
`;

const InfoText = styled.p`
  font-family: var(--body);
  font-size: 15.5px;
  line-height: 1.65;
  color: var(--fg-1);
  margin: 0 0 12px;

  a { color: var(--blue); text-decoration: underline; }
  a:hover { color: var(--fg-0); }
`;

const LastUpdated = styled.p`
  font-family: var(--mono);
  font-size: 11px;
  color: var(--fg-3);
  text-transform: uppercase;
  letter-spacing: 0.28px;
  margin-top: 48px;
  padding-top: 24px;
  border-top: 1px solid var(--line-2);
`;

export default Terms;
